import React from 'react';
import { useTranslation } from 'react-i18next';

export function FaqDbd(): JSX.Element {
  const { t } = useTranslation(['dbd']);
  const faq = [1, 2, 3, 4, 5, 6, 7, 8, 9, 15, 10, 11, 12, 13, 14];

  const toggleCollapse = (index: number): void => {
    const card = document.getElementById(`card-${index}`);

    if (card) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const collapse: any = card.getElementsByClassName('collapse')[0];
      const collapseHeight = collapse.scrollHeight;

      if (card.classList.contains('show')) {
        collapse.style.height = '0px';
        card.classList.remove('show');
      } else {
        collapse.style.height = `${collapseHeight}px`;
        card.classList.add('show');
      }
    }
  };

  return (
    <div className='faq-container'>
      <div className='container-title'>
        <h2>{t('dbd:faq.title')}</h2>
        <p>{t('dbd:faq.description')}</p>
      </div>

      <div className='faq-component'>
        <ul className='accordion'>
          {faq.map((item) => (
            <li className='card bg-transparent' key={`card-${item}`} id={`card-${item}`}>
              <div className='card-header bg-transparent'>
                <h2 className='mb-0'>
                  <button
                    id={`card-faq-${item}`}
                    className='btn btn-faq'
                    type='button'
                    onClick={() => toggleCollapse(item)}
                  >
                    {t(`dbd:faq.title${item}`)}
                  </button>
                </h2>
              </div>

              <div className='collapse'>
                <div className='card-body'>
                  <div className='row'>
                    <div className='col-12 col-lg-10 description'>
                      {t(`dbd:faq.description${item}`)}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className='mt-5 text-center'>
        <h3 className='h5'>{t('dbd:faq.endfaq1')}</h3>
        <p>
          {t('dbd:faq.endfaq2')}
          <a
            href={t('dbd:faq.endfaqLink')}
            target='_blank'
            className='faq-end-link'
            rel='noopener noreferrer'
          >
            {t('dbd:faq.endfaqLink')}
          </a>
        </p>
      </div>
    </div>
  );
}
